/*
 * Complete the look ("Mach den Look komplett") — selectable bundle.
 *
 * - Each tile has a checkbox (pre-checked). A live total reflects the checked items.
 * - The button adds every CHECKED item to the cart in one request, then opens/refreshes
 *   the cart drawer via the theme's cart:change contract.
 * - The current product's size selector stays in sync with the main variant picker.
 *
 * Delegated on document because the block is injected asynchronously by
 * <product-recommendations> (inline scripts in injected HTML would not run).
 */
(function () {
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var LOCALE = document.documentElement.getAttribute('lang') || 'de';

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format(value);
    } catch (e) {
      return value.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function drawerSectionId(drawer) {
    if (!drawer) return '';
    var section = drawer.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : '';
  }

  function itemVariant(item) {
    var sel = item.querySelector('[data-clook-size]');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      return {
        id: sel.value,
        price: Number((opt && opt.getAttribute('data-price')) || 0),
        compare: Number((opt && opt.getAttribute('data-compare')) || 0)
      };
    }
    return {
      id: item.getAttribute('data-variant'),
      price: Number(item.getAttribute('data-vprice') || 0),
      compare: Number(item.getAttribute('data-vcompare') || 0)
    };
  }

  // Render a price element, showing the struck compare-at price when the item is on sale.
  function setPrice(el, price, compare) {
    if (!el) return;
    if (compare && compare > price) {
      el.innerHTML = '<s class="clook__price-was">' + money(compare) + '</s> <span class="clook__price-now">' + money(price) + '</span>';
    } else {
      el.textContent = money(price);
    }
  }

  function updateBundle(root) {
    if (!root) return;
    var total = 0;
    var compareTotal = 0;
    var count = 0;
    root.querySelectorAll('[data-clook-item]').forEach(function (item) {
      var v = itemVariant(item);
      setPrice(item.querySelector('[data-clook-price]'), v.price, v.compare);
      var chk = item.querySelector('[data-clook-check]');
      var on = chk ? chk.checked : true;
      item.classList.toggle('is-off', !on);
      if (on) {
        total += v.price;
        compareTotal += (v.compare && v.compare > v.price) ? v.compare : v.price;
        count += 1;
      }
    });
    var countEl = root.querySelector('[data-clook-count]');
    if (countEl) countEl.textContent = count;
    var totalEl = root.querySelector('[data-clook-total]');
    if (totalEl) {
      if (compareTotal > total) {
        totalEl.innerHTML = '<s class="clook__price-was">' + money(compareTotal) + '</s> ' + money(total);
      } else {
        totalEl.textContent = money(total);
      }
    }
    var btn = root.querySelector('[data-clook-add]');
    if (btn) btn.disabled = count === 0;
  }

  // Main variant picker -> bundle: mirror the selected size on the current-product selector.
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.id) return;
    var id = String(variant.id);
    document.querySelectorAll('[data-clook-current-size]').forEach(function (sel) {
      if (sel.querySelector('option[value="' + id + '"]')) {
        sel.value = id;
        updateBundle(sel.closest('.clook'));
      }
    });
  });

  // Recompute on checkbox / size changes.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && (el.matches('[data-clook-check]') || el.matches('[data-clook-size]'))) {
      updateBundle(el.closest('.clook'));
    }
  });

  // Add every checked item.
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-clook-add]');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();

    var root = btn.closest('.clook');
    if (!root) return;

    var items = [];
    root.querySelectorAll('[data-clook-item]').forEach(function (item) {
      var chk = item.querySelector('[data-clook-check]');
      if (chk && !chk.checked) return;
      var v = itemVariant(item);
      if (v.id) items.push({ id: v.id, quantity: 1 });
    });
    if (!items.length) return;

    var base = rootUrl();
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawerSectionId(drawer);
    var body = { items: items };
    if (sectionId) body.sections = sectionId;

    btn.setAttribute('aria-busy', 'true');

    try {
      var res = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('add failed');

      var added = await res.json();
      var cart = await (await fetch(base + 'cart.js')).json();
      if (added.sections) cart.sections = added.sections;

      if (drawer) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart }
        }));
      } else {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.location.href = base + 'cart';
      }
    } catch (err) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: { error: 'complete-the-look' }
      }));
    } finally {
      btn.setAttribute('aria-busy', 'false');
    }
  });
})();
